module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-brands-400.ttf?77ace0fee45b138f023459bf3af34ba0";